export { useSimuladorEnergiaSolarState } from './model/state';
export { SimuladorSolarProvider } from './widgets/SimuladorSolarProvider';

export { default as SimuladorSolarFormLanding } from './view/FormLanding/FormLanding';
export { default as SimuladorSolarModalTerms } from './view/ModalTerms/ModalTerms';
export { default as SimuladorSolarPage } from './view/PageSimulador/PageSimulador';
